













































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Loading } from "element-ui";
import store from "@/store";
import { collectionListBySearch, productListBySearch } from "@/services/api";
import { getShippingCountryOptions } from "@/services/coupon";
import { parseJsonArray } from "@/utils/couponRulePayload";

type ScopeItem = {
  id: string;
  title: string;
  imageUrl?: string;
  subtitle?: string;
  /** true：反选排除，仍保留在列表中但不计入生效范围 */
  excluded?: boolean;
};

@Component({
  directives: {
    loading: Loading.directive
  }
})
export default class discountDialog extends Vue {
  @Prop()
  discountDialogShow!: boolean;

  @Prop()
  handleClose!: Function;

  @Prop()
  close!: Function;

  @Prop()
  discountData?: any;

  @Prop({ default: '折扣码设置' })
  dialogTitle!: string;

  @Prop({ default: false })
  hideReserveCode!: boolean;

  @Prop({ default: false })
  showCouponNameField!: boolean;

  /** 仅统一折扣码创建入口传 true，避免旧版内嵌折扣规则误建免运费券。 */
  @Prop({ default: false })
  enableFreeShipping!: boolean;

  /** modal：独立弹窗；embedded：内嵌表单（由父级控制确认按钮） */
  @Prop({ default: 'modal' })
  variant!: 'modal' | 'embedded';

  @Prop({ default: '保存设置' })
  confirmText!: string;

  @Prop({ default: '' })
  sourceType!: string;

  get isCustomerSystem() {
    return this.sourceType === 'CUSTOMER_SYSTEM';
  }

  customerRuleIdRules = [
    { required: true, message: '请输入规则ID', trigger: 'blur' },
    { pattern: /^\d+$/, message: '请输入纯数字规则ID', trigger: 'blur' }
  ];

  customerCouponName = '';
  customerCouponNameLoading = false;
  customerCouponNameError = '';

  async onCustomerRuleIdBlur() {
    const ruleId = this.discount.customerRuleId;
    if (!ruleId || !/^\d+$/.test(ruleId)) {
      this.customerCouponName = '';
      this.customerCouponNameError = '';
      return;
    }
    this.customerCouponNameLoading = true;
    this.customerCouponName = '';
    this.customerCouponNameError = '';
    try {
      const { queryCustomerCouponName } = await import('@/services/coupon');
      const name = await queryCustomerCouponName(ruleId);
      this.customerCouponName = name || '';
      if (!name) {
        this.customerCouponNameError = '未找到该优惠券';
      }
    } catch {
      this.customerCouponName = '';
      this.customerCouponNameError = '查询失败，请检查规则ID';
    } finally {
      this.customerCouponNameLoading = false;
    }
  }

  discount = this.initDiscountData(this.discountData);

  countryScope: "ALL" | "SPECIFIC" = parseJsonArray(this.discount.countryCodes).length ? "SPECIFIC" : "ALL";
  countryOptions: Array<{ label: string; value: string }> = [];
  countryOptionsLoading = false;
  countrySearchKeyword = '';

  pickerVisible = false;
  pickerMode: "collection" | "product" = "collection";
  pickerSearch = "";
  pickerRows: ScopeItem[] = [];
  pickerRowMeta: Record<string, ScopeItem> = {};
  pickerSelected: Record<string, boolean> = {};
  pickerLoading = false;
  pickerPage = 1;
  pickerPageSize = 20;
  pickerTotal = 0;
  pickerFetchTimer: any = null;

  // 动态折扣码 - 指定系列/商品最多可选数量
  MAX_SCOPE_ITEMS = 100;

  initDiscountData(data: any) {
    const combine = {
      combinesWithProduct: false,
      combinesWithOrder: false,
      combinesWithShipping: false
    };
    const legacyBase: any = {
      valueType: 2,
      minBuyRequireType: 0,
      ...combine
    };

    const advancedBase: any = {
      ...legacyBase,
      uniqueDiscountType: "ORDER_AMOUNT_DISCOUNT",
      applyScopeType: "COLLECTIONS",
      applyScopeIds: [] as string[],
      applyScopeItems: [] as ScopeItem[],
      appliesOncePerOrder: false,
      couponName: '',
      expireType: 0,
      expireValue: undefined as number | undefined,
      expireValueType: 'day',
      expireDate: '',
      countryCodes: [] as string[],
      startAt: '',
    };
    const discountData = JSON.parse(JSON.stringify({ ...advancedBase, ...(data || {}) }));
    if (discountData.uniqueDiscountType === undefined) {
      discountData.uniqueDiscountType = "ORDER_AMOUNT_DISCOUNT";
    }
    if (discountData.applyScopeType === undefined) {
      discountData.applyScopeType = "COLLECTIONS";
    }
    // 处理 applyScopeIds / applyScopeItems：可能是 JSON 字符串或数组（复用线上 parseJsonArray）
    discountData.applyScopeIds = parseJsonArray(discountData.applyScopeIds).map((id: any) => String(id));
    discountData.applyScopeItems = parseJsonArray(discountData.applyScopeItems);
    discountData.countryCodes = parseJsonArray(discountData.countryCodes).map((code: any) => String(code).toUpperCase());
    if (discountData.appliesOncePerOrder === undefined) {
      discountData.appliesOncePerOrder = true;
    }
    if (discountData.combinesWithProduct === undefined) {
      discountData.combinesWithProduct = false;
    }
    if (discountData.combinesWithOrder === undefined) {
      discountData.combinesWithOrder = false;
    }
    if (discountData.combinesWithShipping === undefined) {
      discountData.combinesWithShipping = false;
    }
    if (discountData.expireType === undefined) {
      discountData.expireType = 0;
    }
    if (discountData.expireValueType === undefined || !discountData.expireValueType) {
      discountData.expireValueType = 'day';
    }
    if (discountData.expireValue === '' || discountData.expireValue === null) {
      discountData.expireValue = undefined;
    }
    if (discountData.expireDate === undefined || discountData.expireDate === null) {
      discountData.expireDate = '';
    }
    return discountData;
  }

  get isModalVariant() {
    return this.variant === 'modal';
  }

  get shouldRenderWrapper() {
    return this.isModalVariant || this.discountDialogShow;
  }

  get wrapperComponent() {
    return this.isModalVariant ? 'el-dialog' : 'div';
  }

  get wrapperBind() {
    if (this.isModalVariant) {
      return {
        title: this.dialogTitle,
        visible: this.discountDialogShow,
        class: this.isCustomerSystem ? 'discount-dialog customer-discount-dialog' : 'discount-dialog',
        customClass: 'discount-dialog',
        width: '512px',
        marginTop: '60px',
        appendToBody: true,
        closeOnClickModal: false,
        showClose: true,
        beforeClose: this.onBeforeCloseDialog,
      };
    }
    return {
      class: 'discount-embedded',
    };
  }

  get expireDatePickerOptions() {
    return {
      disabledDate: (time: Date) => time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
    };
  }

  get startAtPickerOptions() {
    return {
      disabledDate: (time: Date) => time.getTime() < new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
    };
  }

  get startAtType(): "SEND_TIME" | "SPECIFIED" {
    return this.discount.startAt ? "SPECIFIED" : "SEND_TIME";
  }

  onExpireTypeChange(type: number) {
    if (type === 0) {
      this.discount.expireValue = undefined;
      this.discount.expireValueType = 'day';
      this.discount.expireDate = '';
    } else if (type === 1) {
      this.discount.expireDate = '';
      if (this.discount.expireValueType !== 'hour' && this.discount.expireValueType !== 'day') {
        this.discount.expireValueType = 'day';
      }
    } else if (type === 2) {
      this.discount.expireValue = undefined;
    }
  }

  normalizeExpireValue(value: number | undefined) {
    if (value === undefined || value === null || Number.isNaN(value)) {
      this.discount.expireValue = undefined;
      return;
    }
    const numValue = Math.floor(Number(value));
    if (numValue < 1) {
      this.discount.expireValue = 1;
    } else if (numValue > 99999) {
      this.discount.expireValue = 99999;
    } else {
      this.discount.expireValue = numValue;
    }
  }

  /** 保存时过滤被排除的项 */
  submitDiscountPayload() {
    const raw = JSON.parse(JSON.stringify(this.discount));
    if (this.isCustomerSystem) {
      raw.couponId = 'CUST_' + (raw.customerRuleId || '');
    }
    if (raw.expireType !== 1) {
      raw.expireValue = null;
      raw.expireValueType = null;
    }
    if (raw.expireType !== 2) {
      raw.expireDate = null;
    }
    if (raw.expireType === 0) {
      raw.expireValue = null;
      raw.expireValueType = null;
      raw.expireDate = null;
    }
    if (raw.uniqueDiscountType === 'FREE_SHIPPING_DISCOUNT') {
      raw.valueType = null;
      raw.amount = null;
      raw.percent = null;
      raw.countryCodes = this.countryScope === 'SPECIFIC' ? raw.countryCodes : [];
      raw.combinesWithShipping = false;
    } else {
      raw.countryCodes = [];
      raw.startAt = '';
    }
    // 过滤 applyScopeIds，只保留未被排除的项
    const excludedSet = new Set(
      raw.applyScopeItems
        ?.filter((i: ScopeItem) => i.excluded)
        ?.map((i: ScopeItem) => i.id) || []
    );
    raw.applyScopeIds = (raw.applyScopeIds || []).filter((id: string) => !excludedSet.has(id));
    return raw;
  }

  get applyScopeCount() {
    return this.discount.applyScopeIds?.length || 0;
  }

  /** 有效（未反选排除）的生效范围数量 */
  get effectiveApplyScopeCount() {
    return this.discount.applyScopeItems?.filter((i: ScopeItem) => !i.excluded).length || 0;
  }

  scopeItemSubtitle(it: ScopeItem, kind: "collection" | "product") {
    if (it.subtitle) {
      return it.subtitle;
    }
    return kind === "collection" ? `ID: ${it.id}` : `ID: ${it.id}`;
  }

  /** el-checkbox @change：是否参与折扣（勾选 = 参与） */
  onEchoRowCheck(it: ScopeItem, val: any) {
    const included = typeof val === "boolean" ? val : false;
    const row = this.discount.applyScopeItems.find((x: ScopeItem) => x.id === it.id);
    if (!row) {
      return;
    }
    this.$set(row, "excluded", !included);
  }

  get companyId(): number | undefined {
    const c = store.state.companyInfo as any;
    return c?.id ?? JSON.parse(localStorage.getItem("companyInfo") || "{}")?.id;
  }

  get currencySuffix(): string {
    const c = JSON.parse(localStorage.getItem("companyInfo") || "{}");
    const sym = c?.currencySymbol;
    if (sym && typeof sym === "string") {
      return sym;
    }
    return c?.currency === "CNY" ? "¥" : "$";
  }

  get pickerTitle() {
    return this.pickerMode === "collection" ? "选择系列" : "选择商品";
  }

  get pickerSearchPlaceholder() {
    return this.pickerMode === "collection" ? "搜索系列..." : "搜索产品名称、产品ID...";
  }

  get pickerSelectedCount() {
    return Object.keys(this.pickerSelected).filter((k) => this.pickerSelected[k]).length;
  }

  isPickerItemDisabled(row: any): boolean {
    const isCurrentlySelected = !!this.pickerSelected[row.id];
    if (isCurrentlySelected) {
      return false; // 已选中的允许取消
    }
    return this.pickerSelectedCount >= this.MAX_SCOPE_ITEMS;
  }

  get pickerPageAllSelected(): boolean {
    if (!this.pickerRows.length) {
      return false;
    }
    return this.pickerRows.every((r) => this.pickerSelected[r.id]);
  }

  get pickerAllIndeterminate(): boolean {
    const n = this.pickerRows.length;
    if (!n) {
      return false;
    }
    const c = this.pickerRows.filter((r) => this.pickerSelected[r.id]).length;
    return c > 0 && c < n;
  }

  get filteredCountryOptions(): Array<{ label: string; value: string }> {
    if (!this.countrySearchKeyword) {
      return this.countryOptions;
    }
    return this.countryOptions.filter((item) =>
      `${item.label} ${item.value}`.toLowerCase().includes(this.countrySearchKeyword)
    );
  }

  // immediate：一键转换 embedded 首次挂载时 show 已是 true，无 immediate 则不会拉生效范围回显
  @Watch("discountDialogShow", { immediate: true })
  async changeData() {
    if (this.discountDialogShow) {
      this.discount = this.initDiscountData(this.discountData);
      this.countryScope = this.discount.countryCodes.length ? 'SPECIFIC' : 'ALL';
      this.countrySearchKeyword = '';
      // 自定义优惠券：清掉上一次的优惠券名称，避免跨行/跨折扣位残留
      this.customerCouponName = '';
      this.customerCouponNameError = '';
      this.customerCouponNameLoading = false;
      if (this.isCustomerSystem) {
        // 已保存的规则ID直接回显名称，无需等用户手动失焦
        if (this.discount.customerRuleId) {
          await this.onCustomerRuleIdBlur();
        }
        return;
      }
      if (this.discount.uniqueDiscountType === 'FREE_SHIPPING_DISCOUNT') {
        await this.loadShippingCountryOptions();
      }
      // 如果有生效范围ID但没有详细信息，查询接口回显
      await this.fetchScopeDetailsIfNeeded();
    }
  }
  /** 如果有 applyScopeIds 但没有 applyScopeItems，查询接口获取详情 */
  async fetchScopeDetailsIfNeeded() {
    // 必须是产品定额折扣且有生效范围ID
    if (this.discount.uniqueDiscountType !== "PRODUCT_AMOUNT_DISCOUNT") {
      return;
    }
    console.log('this.discount.uniqueDiscountType==', this.discount.applyScopeIds);
    const ids = this.discount.applyScopeIds;
    if (!ids || !ids.length) {
      return;
    }
    const cid = this.companyId;
    if (!cid) {
      return;
    }
    console.log('fetchScopeDetailsIfNeeded', this.discount.applyScopeType);
    try {
      if (this.discount.applyScopeType === "COLLECTIONS") {
        await this.fetchCollectionDetails(cid, ids);
      } else if (this.discount.applyScopeType === "PRODUCTS") {
        await this.fetchProductDetails(cid, ids);
      }
    } catch (e) {
      console.error("Fetch scope details failed:", e);
    }
  }
  async fetchCollectionDetails(companyId: number, ids: string[]) {
    const res = await collectionListBySearch({
      companyId,
      currentPage: 1,
      pageSize: Math.min(1000, Math.max(50, ids.length * 2)),
      collectionIds: ids
    } as any, false);
    const rows = this.extractListPayload(res);
    const rowMap = new Map<string, any>();
    rows.forEach((r) => {
      const normalized = this.normalizeCollectionRow(r);
      if (normalized.id) {
        rowMap.set(normalized.id, r);
      }
    });
    // 用接口数据填充 items
    this.discount.applyScopeItems = ids.map((id) => {
      const row = rowMap.get(id);
      if (row) {
        return this.normalizeCollectionRow(row);
      }
      return { id, title: id, excluded: false };
    });
  }
  async fetchProductDetails(companyId: number, ids: string[]) {
    const res = await productListBySearch({
      companyId,
      currentPage: 1,
      pageSize: Math.min(1000, Math.max(50, ids.length * 2)),
      productIds: ids
    } as any, false);
    const rows = this.extractListPayload(res);
    const rowMap = new Map<string, any>();
    rows.forEach((r) => {
      const normalized = this.normalizeProductRow(r);
      if (normalized.id) {
        rowMap.set(normalized.id, r);
      }
    });
    // 用接口数据填充 items
    this.discount.applyScopeItems = ids.map((id) => {
      const row = rowMap.get(id);
      if (row) {
        return this.normalizeProductRow(row);
      }
      return { id, title: id, excluded: false, imageUrl: undefined };
    });
  }
  // changeData() {
  //   if (this.discountDialogShow) {
  //     this.discount = this.initDiscountData(this.discountData);
  //   }
  // }

  onBeforeCloseDialog(done: () => void) {
    this.beforeClose();
    done();
  }

  onDiscountCodeTypeChange() {
    if (this.discount.uniqueDiscountType === "ORDER_AMOUNT_DISCOUNT") {
      this.pickerVisible = false;
    }
    // 切换到产品定额折扣且当前为固定金额时，默认勾选每笔订单仅应用一次折扣
    if (this.discount.uniqueDiscountType === "PRODUCT_AMOUNT_DISCOUNT") {
      // 需要将生效范围默认设置为系列
      this.discount.applyScopeType = "COLLECTIONS";
      if (this.discount.valueType === 1) { 
        this.discount.appliesOncePerOrder = true;
      }
      (window as any)?.gtagClick?.("form_edit_setDisc_productDisc", "弹窗_编辑订阅工具_设置动态折扣码_产品折扣");
    }
    if (this.discount.uniqueDiscountType === 'FREE_SHIPPING_DISCOUNT') {
      // 免运费没有折扣值，且 Shopify 不允许与其他运费折扣叠加。
      this.discount.valueType = null;
      this.discount.amount = '';
      this.discount.percent = '';
      this.discount.combinesWithShipping = false;
      this.countryScope = this.discount.countryCodes.length ? 'SPECIFIC' : 'ALL';
      this.loadShippingCountryOptions();
      return;
    }
    this.discount.countryCodes = [];
    this.discount.startAt = '';
    this.countryScope = 'ALL';
    if (!this.discount.valueType) {
      this.discount.valueType = 2;
    }
  }

  onCountryScopeChange(scope: "ALL" | "SPECIFIC") {
    this.countryScope = scope;
    if (scope === 'ALL') {
      this.discount.countryCodes = [];
    } else {
      this.loadShippingCountryOptions();
    }
  }

  onStartAtTypeChange(type: "SEND_TIME" | "SPECIFIED") {
    this.discount.startAt = type === 'SEND_TIME' ? '' : this.defaultStartAt();
  }

  defaultStartAt() {
    const date = new Date(Date.now() + 60 * 60 * 1000);
    const pad = (value: number) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  filterCountryOptions(keyword: string) {
    this.countrySearchKeyword = String(keyword || '').trim().toLowerCase();
  }

  async loadShippingCountryOptions() {
    if (this.countryOptionsLoading || this.countryOptions.length) {
      return;
    }
    this.countryOptionsLoading = true;
    try {
      const { data: resp } = await getShippingCountryOptions();
      if (resp?.code === 0) {
        this.countryOptions = (resp.data || []).map((item: any) => {
          const code = String(item.countryAbbreviation || '').toUpperCase();
          const name = item.countryName || item.country || code;
          return { value: code, label: `${name} (${code})` };
        }).filter((item) => item.value);
      }
    } catch {
      // commonApi 拦截器统一提示接口错误。
    } finally {
      this.countryOptionsLoading = false;
    }
  }

  onScopeTypeChange() {
    // 切换生效范围类型时，清空已选项
    this.discount.applyScopeIds = [];
    this.discount.applyScopeItems = [];
  }

  onValueTypeChange() {
    // 产品定额折扣 + 固定金额时，默认勾选每笔订单仅应用一次折扣
    if (this.discount.valueType === 1 &&
        this.discount.uniqueDiscountType === "PRODUCT_AMOUNT_DISCOUNT") {
      this.discount.appliesOncePerOrder = true;
    }
  }

  beforeClose() {
    this.pickerVisible = false;
    (this.$refs as any)?.form?.clearValidate && (this.$refs as any).form.clearValidate();
    (this.$refs as any)?.form?.resetFields && (this.$refs as any).form.resetFields();
    this.close && this.close();
  }

  clearKongge() {
    this.discount.codePrefix = `${this.discount.codePrefix ?? ""}`.replace(/\s+/g, "").substring(0, 10);
  }
  clear30() {
    this.discount.reserveCode = `${this.discount.reserveCode ?? ""}`.substring(0, 30);
  }

  onCouponNameInput(val: string) {
    this.discount.couponName = `${val ?? ""}`.slice(0, 100);
  }

  openPicker(mode: "collection" | "product") {
    if (!this.companyId) {
      this.$message.error("未获取到店铺信息，请重新登录后重试");
      return;
    }
    this.pickerMode = mode;
    this.pickerSearch = "";
    this.pickerPage = 1;
    this.pickerSelected = {};
    this.pickerRowMeta = {};
    // 从 applyScopeIds 初始化选择状态（所有已选项都显示为选中）
    this.discount.applyScopeIds.forEach((id: string) => {
      this.$set(this.pickerSelected, id, true);
    });
    // 从 applyScopeItems 初始化元数据（包括 excluded 状态）
    this.discount.applyScopeItems.forEach((it: ScopeItem) => {
      this.pickerRowMeta[it.id] = { ...it };
    });
    this.pickerVisible = true;
  }

  onPickerOpen() {
    this.fetchPickerRows();
  }

  schedulePickerFetch() {
    if (this.pickerFetchTimer) {
      clearTimeout(this.pickerFetchTimer);
    }
    this.pickerFetchTimer = setTimeout(() => {
      this.pickerPage = 1;
      this.fetchPickerRows();
    }, 320);
  }

  syncPickerKeys(row: ScopeItem) {
    if (this.pickerSelected[row.id]) {
      this.pickerRowMeta[row.id] = { ...this.pickerRowMeta[row.id], ...row };
    }
  }

  onTogglePickerPageAll(checked: boolean) {
    this.pickerRows.forEach((r) => {
      this.$set(this.pickerSelected, r.id, checked);
      if (checked) {
        this.pickerRowMeta[r.id] = { id: r.id, title: r.title, imageUrl: r.imageUrl, subtitle: r.subtitle };
      }
    });
  }

  invertPickerPage() {
    this.pickerRows.forEach((r) => {
      const next = !this.pickerSelected[r.id];
      this.$set(this.pickerSelected, r.id, next);
      if (next) {
        this.pickerRowMeta[r.id] = { id: r.id, title: r.title, imageUrl: r.imageUrl, subtitle: r.subtitle };
      }
    });
  }

  async fetchPickerRows() {
    const cid = this.companyId;
    if (!cid) {
      return;
    }
    this.pickerLoading = true;
    try {
      if (this.pickerMode === "collection") {
        await this.loadCollectionPicker(cid);
      } else {
        await this.loadProductPicker(cid);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.pickerLoading = false;
    }
  }

  sortByCreateTimeDesc(rows: any[]) {
    const t = (x: any) => {
      const raw = x.createTime || x.createdAt || x.gmtCreate || x.create_time || "";
      const n = Date.parse(raw);
      return Number.isNaN(n) ? 0 : n;
    };
    return [...rows].sort((a, b) => t(b) - t(a));
  }

  normalizeCollectionRow(row: any): ScopeItem {
    const id = `${row.collectionId ?? ""}`.trim();
    const title = row.title || row.name || row.collectionName || "";
    const extId = `${row.shopifyCollectionId ?? row.handle ?? ""}`.trim();
    const subtitle = extId && extId !== id ? `ID: ${extId}` : (id ? `ID: ${id}` : "");
    const imageUrl = row.imageUrl || row.image || row.featuredImageUrl || row.coverImage || "";
    return { id, title, subtitle, imageUrl: imageUrl || undefined };
  }

  normalizeProductRow(row: any): ScopeItem {
    const id = `${row.productId ?? ""}`.trim();
    const name = row.productName || row.title || row.name || "";
    const pid = `${row.shopifyProductId ?? row.externalId ?? ""}`.trim();
    const title = name;
    const subtitle = pid ? `ID: ${pid}` : "";
    const imageUrl = row.imageUrl || row.image || row.thumbnailUrl || row.featuredImage || "";
    return { id, title, subtitle, imageUrl: imageUrl || undefined };
  }

  extractListPayload(res: any): any[] {
    const d = res?.data?.data;
    if (Array.isArray(d)) {
      return d;
    }
    if (Array.isArray(res?.data)) {
      return res.data;
    }
    return [];
  }

  extractTotal(res: any): number {
    // 尝试多种可能的分页数据结构
    const p = res?.data?.pageInfo || res?.data?.page_info || res?.pageInfo;
    if (p && typeof p.total === "number") {
      return p.total;
    }
    // 有些接口返回 total 在 data 下
    if (typeof res?.data?.total === "number") {
      return res.data.total;
    }
    // 如果都没有，返回当前数据长度（表示只有一页）
    const d = this.extractListPayload(res);
    return d.length;
  }

  async loadCollectionPicker(companyId: number) {
    const res = await collectionListBySearch({
      companyId,
      currentPage: this.pickerPage,
      pageSize: this.pickerPageSize,
      collectionName: `${this.pickerSearch || ""}`.trim()
    }, false);
    this.pickerTotal = this.extractTotal(res);
    this.pickerRows = this.sortByCreateTimeDesc(this.extractListPayload(res))
      .map((r) => this.normalizeCollectionRow(r))
      .filter((r) => r.id);
    this.pickerRows.forEach((r) => {
      this.pickerRowMeta[r.id] = r;
    });
  }

  async loadProductPicker(companyId: number) {
    const kw = `${this.pickerSearch || ""}`.trim();
    const params: any = {
      companyId,
      currentPage: this.pickerPage,
      pageSize: this.pickerPageSize
    };
    if (kw) {
      // 纯数字搜索 productIds（数组），其他搜索 productName
      if (/^\d+$/.test(kw)) {
        params.productIds = [kw];
      } else {
        params.productName = kw;
      }
    }
    const res = await productListBySearch(params, false);
    const raw = this.sortByCreateTimeDesc(this.extractListPayload(res));
    this.pickerTotal = this.extractTotal(res);
    this.pickerRows = raw.map((r) => this.normalizeProductRow(r)).filter((r) => r.id);
    this.pickerRows.forEach((r) => {
      this.pickerRowMeta[r.id] = r;
    });
  }

  confirmPicker() {
    const ids = Object.keys(this.pickerSelected).filter((k) => this.pickerSelected[k]);
    if (ids.length > this.MAX_SCOPE_ITEMS) {
      this.$message.error(`最多只能选择 ${this.MAX_SCOPE_ITEMS} 个系列/商品`);
      return;
    }
    if (!ids.length) {
      this.$message.warning("请至少选择一项");
      return;
    }
    // 合并现有 items 和新选择的 items，保留现有项的 excluded 状态
    const existingById = new Map<string, ScopeItem>();
    (this.discount.applyScopeItems || []).forEach((it: ScopeItem) => {
      existingById.set(it.id, it);
    });
    
    const items: ScopeItem[] = [];
    ids.forEach((id) => {
      const existing = existingById.get(id);
      if (existing) {
        // 保留现有项（包括 excluded 状态）
        items.push(existing);
      } else {
        // 新增项，默认 excluded 为 false
        const meta = this.pickerRowMeta[id] || { id, title: id };
        items.push({
          id: meta.id,
          title: meta.title,
          subtitle: meta.subtitle,
          imageUrl: meta.imageUrl,
          excluded: false,
        });
      }
    });
    this.discount.applyScopeIds = ids;
    this.discount.applyScopeItems = items;
    this.pickerVisible = false;
  }

  removeScopeItem(id: string) {
    this.discount.applyScopeIds = this.discount.applyScopeIds.filter((x: string) => x !== id);
    this.discount.applyScopeItems = this.discount.applyScopeItems.filter((x: ScopeItem) => x.id !== id);
  }

  validateProductScope(): string | null {
    if (this.discount.uniqueDiscountType !== "PRODUCT_AMOUNT_DISCOUNT") {
      return null;
    }
    // 检查有效（未反选排除）的项目数量
    const effectiveCount = this.discount.applyScopeItems?.filter((i: ScopeItem) => !i.excluded).length || 0;
    if (effectiveCount === 0) {
      return this.discount.applyScopeType === "COLLECTIONS"
        ? "产品定额折扣下请至少选择一个系列"
        : "产品定额折扣下请至少选择一个商品";
    }
    return null;
  }

  validateFreeShipping(): string | null {
    if (this.discount.uniqueDiscountType !== 'FREE_SHIPPING_DISCOUNT') {
      return null;
    }
    if (this.countryScope === 'SPECIFIC' && !this.discount.countryCodes.length) {
      return '请至少选择一个适用国家';
    }
    // startAt 是店铺当地时间字符串，不能按运营人员浏览器时区在前端比较；由后端按店铺时区校验。
    return null;
  }

  validateAndSave() {
    this.validAndClose();
  }

  validAndClose() {
    (this.$refs as any).form?.validate(async (valid: boolean) => {
      if (!valid) {
        return false;
      }
      const scopeErr = this.validateProductScope();
      if (scopeErr) {
        this.$message.error(scopeErr);
        return false;
      }
      const freeShippingErr = this.validateFreeShipping();
      if (freeShippingErr) {
        this.$message.error(freeShippingErr);
        return false;
      }
      this.handleClose && this.handleClose(this.submitDiscountPayload());
      if (this.isModalVariant) {
        (window as any)?.gtagClick?.("form_edit_setDiscountCode", "弹窗_编辑订阅工具_设置动态折扣码");
      }
    });
  }

  changeDiscountAmount() {
    const strArr = `${this.discount.amount ?? ""}`.split(".");
    let start = strArr[0];
    let end = strArr.length > 1 ? strArr[1] : "";
    this.discount.amount = `${start}`.substring(0, 9) + (strArr.length > 1 ? ("." + `${end}`.substring(0, 2)) : "");
  }

  changeMinBuyAmount() {
    const strArr = `${this.discount.minBuyAmount ?? ""}`.split(".");
    let start = strArr[0];
    let end = strArr.length > 1 ? strArr[1] : "";
    this.discount.minBuyAmount = `${start}`.substring(0, 9) + (strArr.length > 1 ? ("." + `${end}`.substring(0, 2)) : "");
  }

  changeMinBuyCount() {
    this.discount.minBuyCount = `${this.discount.minBuyCount ?? ""}`.substring(0, 9);
  }

  isTwoDecimalPlaces(number: any) {
    return /^(\-)?\d+(\.\d{1,2})?$/.test(`${Number(number)}`);
  }

  validateAmount(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || (typeof value === "string" && value.length === 0)) {
      return callback(new Error("值类型不可为空"));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error("仅支持输入数字及小数点后两位"));
      } else {
        if (Number(value) < 0) {
          callback(new Error("仅支持输入数字及小数点后两位"));
        } else {
          if (this.isTwoDecimalPlaces(value)) {
            callback();
          } else {
            callback(new Error("仅支持输入数字及小数点后两位"));
          }
        }
      }
    }, 10);
  }
  validatePercent(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || (typeof value === "string" && value.length === 0)) {
      return callback(new Error("值类型不可为空"));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error("仅支持输入1-100整数数字"));
      } else {
        if (Number(value) < 1 || Number(value) > 100) {
          callback(new Error("仅支持输入1-100整数数字"));
        } else {
          if (Number.isInteger(Number(value))) {
            callback();
          } else {
            callback(new Error("仅支持输入1-100整数数字"));
          }
        }
      }
    }, 10);
  }
  validateMinBuyAmount(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || (typeof value === "string" && value.length === 0)) {
      return callback(new Error("最低购买要求值不可为空"));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error("仅支持输入数字及小数点后两位"));
      } else {
        if (Number(value) < 0) {
          callback(new Error("仅支持输入数字及小数点后两位"));
        } else {
          if (this.isTwoDecimalPlaces(value)) {
            callback();
          } else {
            callback(new Error("仅支持输入数字及小数点后两位"));
          }
        }
      }
    }, 10);
  }
  validateMinBuyCount(rule: any, value: any, callback: any) {
    if (value === undefined || value === null || (typeof value === "string" && value.length === 0)) {
      return callback(new Error("最低购买要求值不可为空"));
    }
    setTimeout(() => {
      if (Number.isNaN(value)) {
        callback(new Error("仅支持输入>0整数数字"));
      } else {
        if (Number(value) < 0) {
          callback(new Error("仅支持输入>0整数数字"));
        } else {
          if (Number.isInteger(Number(value))) {
            callback();
          } else {
            callback(new Error("仅支持输入>0整数数字"));
          }
        }
      }
    }, 10);
  }

  validateExpireValue(rule: any, value: any, callback: any) {
    if (this.discount.expireType !== 1) {
      return callback();
    }
    if (value === undefined || value === null || value === '') {
      return callback(new Error('折扣结束限时值不可为空'));
    }
    const numValue = Number(value);
    if (Number.isNaN(numValue) || numValue < 1 || numValue > 99999 || !Number.isInteger(numValue)) {
      return callback(new Error('仅支持输入1-99999整数'));
    }
    callback();
  }

  validateExpireDate(rule: any, value: any, callback: any) {
    if (this.discount.expireType !== 2) {
      return callback();
    }
    if (!value) {
      return callback(new Error('折扣结束固定到期日期值不可为空'));
    }
    callback();
  }
}
